import { ReactNode } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { DSColor } from '@ppwr/poker'
import { DS } from '../../design-system'

interface GameActionsProp {
  leftIcon: ReactNode
  leftIconBg: DSColor
  title: string
  rightIcon: ReactNode
  rightIconBg?: DSColor
  onSelectingOption: () => void
  badgeText?: string
  badgeTone?: 'orange' | 'gray'
}

export const GameActions = ({
  leftIcon,
  leftIconBg,
  title,
  rightIcon,
  onSelectingOption,
  badgeText,
  badgeTone = 'orange'
}: GameActionsProp) => {
  const flagColor = badgeTone === 'gray' ? DS.palette['Brand/Dark Grey'] : DS.palette['Brand/Orange']

  return (
    <TouchableOpacity style={styles.gameShortcut} onPress={onSelectingOption}>
      {badgeText ? (
        <View style={styles.flagBadge}>
          <View style={[styles.flagContainer, { backgroundColor: flagColor }]}>
            <DS.Text variant="Caption/Bold" style={styles.badgeText} numberOfLines={1} ellipsizeMode="clip">
              {badgeText}
            </DS.Text>
          </View>
          <View style={[styles.flagTail, { borderLeftColor: flagColor, borderRightColor: flagColor }]} />
        </View>
      ) : null}
      <View style={styles.leftContainer}>
        <DS.Frame bg={leftIconBg} style={styles.leftIconContainer}>
          {leftIcon}
        </DS.Frame>
        <DS.Text variant="Heading 3/Medium">{title}</DS.Text>
      </View>
      {rightIcon}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  gameShortcut: {
    position: 'relative',
    paddingVertical: 12,
    paddingHorizontal: 16,
    gap: 12,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  leftIconContainer: {
    height: 32,
    width: 32,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center'
  },
  leftContainer: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center'
  },
  flagBadge: {
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 48
  },
  flagContainer: {
    width: 74,
    paddingVertical: 5,
    alignItems: 'center',
    justifyContent: 'center'
  },
  flagTail: {
    borderTopWidth: 0,
    borderBottomWidth: 3,
    borderRightWidth: 37,
    borderLeftWidth: 37,
    borderBottomColor: 'transparent',
    backgroundColor: 'transparent'
  },
  badgeText: {
    color: DS.palette['Global/White'],
    fontSize: 9,
    lineHeight: 10,
    flexShrink: 0
  }
})
